import { combineReducers } from "redux";
import authReducer from "./authReducer";
import clientReducer from "./clientReducer";
import fileReducer from "./fileReducer";
import metadataReducer from "./metadataReducer";
import departmentReducer from "./departmentReducer";
import teamReducer from "./teamReducer";
import roleReducer from "./roleReducer";
import userReducer from "./userReducer";
import workflowReducer from "./workflowReducer";
import pageReducer from "./pageReducer";
import accuracyReducer from "./accuracyReducer";

export default combineReducers({
  auth: authReducer,
  client: clientReducer,
  file: fileReducer,
  metadata: metadataReducer,
  department: departmentReducer,
  team: teamReducer,
  user: userReducer,
  workflow: workflowReducer,
  role: roleReducer,
  accuracy: accuracyReducer,
  page: pageReducer
});
